import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1a6195af3b9b6c48637fbe4fbf954f0d.jpg"
          alt="Fond CTA"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0A2540]/85"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
          Échangeons sur votre projet
        </h2>
        <p className="text-white/70 text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          Contactez-nous pour discuter de vos besoins et découvrir comment BOBROWSKA peut vous accompagner.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-white text-[#0A2540] font-semibold text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap"
        >
          Prendre contact
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}
